export default "/_next/static/images/left_arrow-f640ad2d849e541c6f9a4c0ea9626abb.svg";